import DashboardLatestNews from "organisms/dashboard-latest-news/dashboard-latest-news";
import DashboardPublicationsTabs from "organisms/dashboard-publications-tabs/dashboard-publications-tabs";
import DashboardRecentItems from "organisms/dashboard-recent-items/dashboard-recent-items";
import DashboardUserProfile from "organisms/dashboard-user-profile/dashboard-user-profile";
import ResizeableColumns from "organisms/resizable-containers/resizable-columns";
import React from "react";
import LocalStorageKey from "utilities/enumerations/local-storage-keys";
import UserDashboardPublicationsDropdown from "./user-dashboard-publications-dropdown";
import useModalActions from "utilities/hooks/use-modal-actions";
import useBreakpoint from "utilities/hooks/use-breakpoint";
import { Breakpoints } from "utilities/enumerations/breakpoints";
import UserDashboardBanners from "organisms/banners/user-dashboard-banners";
import FreeTrialBanner from "organisms/banners/free-trial-banner";

const CSS_BASE_CLASS = "c-user-dashboard";
const UserDashboard: React.FC = () => {
    const { isOpen, handleOpen, handleClose } = useModalActions();
    const isDesktop = useBreakpoint(Breakpoints.Tablet);
    return (
        <div className={CSS_BASE_CLASS}>
            <ResizeableColumns
                id={LocalStorageKey.UserDashboardLeftColumnWidthInVw}
                cssClassName={`${CSS_BASE_CLASS}__columns`}>
                <div>
                    <DashboardUserProfile />
                    <FreeTrialBanner />
                    <UserDashboardBanners />
                    {!isDesktop && (
                        <UserDashboardPublicationsDropdown
                            isOpen={isOpen}
                            handleOpen={handleOpen}
                            handleClose={handleClose}
                        />
                    )}
                    {isDesktop && <DashboardRecentItems />}
                </div>
                <div>
                    {isDesktop && (
                        <UserDashboardPublicationsDropdown
                            isOpen={isOpen}
                            handleOpen={handleOpen}
                            handleClose={handleClose}
                        />
                    )}
                    <DashboardPublicationsTabs
                        onOpenPublicationsModal={handleOpen}
                    />
                    {!isDesktop && <DashboardRecentItems />}
                    <DashboardLatestNews />
                </div>
            </ResizeableColumns>
        </div>
    );
};

export default UserDashboard;
